import heroImg from '../assets/hero.png';
import { productIcon } from '../shared/productIcon';
import styles from './TrialHero.module.scss';

export function TrialHero({
  icon,
  title,
  subtitle,
}: {
  icon: string;
  title: string;
  subtitle: string;
}) {
  return (
    <div className={styles.hero}>
      <img className={styles.heroImage} src={heroImg} alt="" />
      <div className={styles.card}>
        <img className={styles.icon} src={productIcon(icon)} alt="" />
        <h1 className={styles.title}>{title}</h1>
        <p className={styles.subtitle}>{subtitle}</p>
      </div>
    </div>
  );
}
